const DEFAULT_ITEMS = [
  "Fleet Operations",
  "AI Call Centres",
  "Enterprise Learning",
  "Crane Rental Operations",
  "Contact-Centre Consulting",
  "Systems Integration",
  "Managed Infrastructure",
  "Business Automation",
];

// Slow editorial marquee. Content is duplicated for a seamless loop.
export const Marquee = ({ items = DEFAULT_ITEMS }) => (
  <div className="overflow-hidden border-y border-slate-200 bg-white py-4" aria-hidden="true">
    <div className="animate-marquee flex w-max items-center gap-10">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center gap-10 whitespace-nowrap">
          <span className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-slate-500">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
        </span>
      ))}
    </div>
  </div>
);
